import React from 'react';
import { Box, Button } from '@material-ui/core';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useEntity } from '@backstage/plugin-catalog-react';

/**
 * Link to open full standalone TechDocs page for current entity.
 * Shown inside the entity page's embedded Documentation tab.
 */
export const OpenFullDocsLink: React.FC = () => {
  const { entity } = useEntity();
  const namespace = entity.metadata.namespace || 'default';
  const kind = entity.kind.toLowerCase();
  const name = entity.metadata.name;
  const docsUrl = `/docs/${namespace}/${kind}/${name}`;

  return (
    <Box display="flex" justifyContent="flex-end" mb={2}>
      <Button
        variant="outlined"
        size="small"
        startIcon={<OpenInNewIcon />}
        href={docsUrl}
        style={{ textTransform: 'none', fontWeight: 600 }}
      >
        Open Full Documentation
      </Button>
    </Box>
  );
};

/**
 * Link back to catalog component page from standalone TechDocs page.
 * Used as a TechDocs addon.
 */
export const BackToComponentLink: React.FC = () => {
  const { entity } = useEntity();
  const namespace = entity.metadata.namespace || 'default';
  const kind = entity.kind.toLowerCase();
  const name = entity.metadata.name;
  const catalogUrl = `/catalog/${namespace}/${kind}/${name}`;

  return (
    <Box mb={2}>
      <Button
        variant="contained"
        size="small"
        startIcon={<ArrowBackIcon />}
        href={catalogUrl}
        style={{
          textTransform: 'none',
          fontWeight: 600,
          backgroundColor: '#2A5A4F',
          color: '#FFFFFF',
        }}
      >
        Back to {entity.metadata.title || name}
      </Button>
    </Box>
  );
};
